import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import { Form, Field } from "react-final-form";
import arrayMutators from "final-form-arrays";
import Modal from "components/new/Modal";
import ModalBody from "components/new/ModalBody";
import ModalFooter from "components/new/ModalFooter";
import Grid from "components/Grid";
import GridCell from "components/GridCell";
import BlockSelector from "components/new/BlockSelector";
import MonthSelector from "./MonthSelector";
import { closeModal } from "containers/App/_actions";

class OutdoorPigSolidApplicationModal extends React.Component {
    submit = (viewModel) => {
        delete viewModel.availableBlocks;
        this.props.modal.onConfirm(viewModel);
        this.props.closeModal();
    };

    render() {
        const { viewModel } = this.props;

        return (
            <Form initialValues={viewModel} mutators={{ ...arrayMutators }} onSubmit={this.submit}>
                {({ form, values, handleSubmit, submitting, submitSucceeded }) => {
                    const disableSave = submitSucceeded || submitting;

                    return (
                        <Modal title={`${viewModel.title} application`} allowOffline={true}>
                            {({ closeModal }) => (
                                <form onSubmit={handleSubmit}>
                                    <ModalBody>
                                        <Grid>
                                            <Field name="id" type="hidden" component="input" />
                                            <GridCell className="u-width4of5">
                                                <Field name="blockIds" availableBlocks={viewModel.availableBlocks} component={BlockSelector} />
                                            </GridCell>
                                        </Grid>
                                        <Grid title="Months">
                                            <GridCell className="u-mt-md">
                                                <MonthSelector form={form} monthsFieldName="months" />
                                            </GridCell>
                                        </Grid>
                                    </ModalBody>
                                    <ModalFooter>
                                        <div className="ButtonBar">
                                            <div className="ButtonBar-left">
                                                <button id="cancel-pig-application" type="button" className="Button Button--secondary" onClick={closeModal}>
                                                    Cancel
                                                </button>
                                            </div>
                                            <div className="ButtonBar-right">
                                                <button id="save-pig-application" type="submit" className="Button" disabled={disableSave}>
                                                    Done
                                                </button>
                                            </div>
                                        </div>
                                    </ModalFooter>
                                </form>
                            )}
                        </Modal>
                    );
                }}
            </Form>
        );
    }
}
export default compose(withAppContext, withActions({ closeModal }))(OutdoorPigSolidApplicationModal);
